// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_TransactionsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_TransactionsResponse — ordered list of platform-revenue
 * transactions for one subscription.
 *
 * Used by GET /subscriptions/(:num)/transactions.
 */
import type { Subscriptions_TransactionRow } from './Subscriptions_TransactionRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subscriptions_TransactionsResponseDados {
rows: Subscriptions_TransactionRow[]
}

export type Subscriptions_TransactionsResponse = ApiResponse<Subscriptions_TransactionsResponseDados>;

registerResponseContract('Subscriptions_TransactionsResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      id:                 { type: 'number',  required: true },
      subscription_id:    { type: 'number',  required: true },
      kind:               { type: 'string',  required: false },
      amount_cents:       { type: 'number',  required: false },
      currency:           { type: 'string',  required: false },
      status:             { type: 'string',  required: false },
      provider:           { type: 'string',  required: false },
      provider_charge_id: { type: 'string',  required: false },
      paid_at:            { type: 'string',  required: false },
      created_at:         { type: 'string',  required: false },
      attempts: {
        type: 'array',
        required: false,
        items: {
          status:     { type: 'string',  required: false },
          event_type: { type: 'string',  required: false },
          created_at: { type: 'string',  required: false },
        },
      },
    },
  },
})
